import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddBucket from "../../../containers/superadmin/buckets/models/add-bucket";
import SearchBar from "../../../containers/superadmin/buckets/searchbar";
import BucketsTable from "../../../containers/superadmin/buckets/table";
import { getAllBucketsRequest } from "../../../modules/superadmin-modules/bucket/Actions";

const SuperAdminBuckets = () => {
  const dispatch = useDispatch();
  const model = useSelector((state) => state.model);
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  useEffect(() => {
    dispatch(getAllBucketsRequest());
  }, []);

  return (
    <Layout>
      <SearchBar setAdd={setAdd} setSelectedData={setSelectedData} />
      <BucketsTable setAdd={setAdd} setSelectedData={setSelectedData} />
      <AddBucket
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default SuperAdminBuckets;
